import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
import { WebGLEngine } from "./WebGLEngine";
export class WebGLVertexBuffer {
    get vertexDeclaration() {
        return this._vertexDeclaration;
    }
    set vertexDeclaration(value) {
        this._vertexDeclaration = value;
        this._shaderValues = this._vertexDeclaration._shaderValues;
    }
    constructor(targetType, bufferUsageType) {
        this._glBuffer = WebGLEngine.instance.createBuffer(targetType, bufferUsageType);
    }
    getStorageBuffer() {
        return null;
    }
    setDataLength(byteLength) {
        this._glBuffer.setDataLength(byteLength);
    }
    setData(buffer, bufferOffset, dataStartIndex, dataCount) {
        this.bind();
        var needSubData = dataStartIndex !== 0 || dataCount !== Number.MAX_SAFE_INTEGER;
        if (needSubData) {
            var subData = new Uint8Array(buffer, dataStartIndex, dataCount);
            this._glBuffer.setData(subData, bufferOffset);
        }
        else {
            this._glBuffer.setData(buffer, bufferOffset);
        }
        LayaGL.statAgent.recordCTData(StatElement.CT_GeometryBufferUploadCount, 1);
    }
    bind() {
        return this._glBuffer.bindBuffer();
    }
    unbind() {
        return this._glBuffer.unbindBuffer();
    }
    orphanStorage() {
        this.bind();
        this._glBuffer.setDataLength(this._glBuffer._byteLength);
    }
    destroy() {
        this._glBuffer.destroy();
        this._vertexDeclaration = null;
    }
}
